// src/components/Dashboard/FulfillableProductsPanel.js
import React from 'react';

const FulfillableProductsPanel = ({ allProductStats }) => {
	// Sort products by fulfillable percentage in descending order
	const sortedProducts = Object.values(allProductStats || {}).sort((a, b) =>
		                                                                 b.fulfillable_percentage - a.fulfillable_percentage
	);

	return (
		<div className="p-5 pt-0">
			<div className="overflow-x-auto">
				{sortedProducts?.length > 0 ? (
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-50">
						<tr>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								SKU
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Name
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Fulfillable
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Unfulfillable
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Fulfillable %
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Affected Orders
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Missing Parts
							</th>
						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{sortedProducts.map((product, index) => (
							<tr key={index} className="hover:bg-gray-50">
								<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
									{product.sku}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{product.name}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-green-500 font-medium">
									{product.fulfillable_count}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-red-500 font-medium">
									{product.unfulfillable_count}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm">
									<div className="flex items-center">
                      <span className={`font-medium ${product.fulfillable_percentage > 50 ? 'text-green-500' : 'text-red-500'}`}>
                        {product.fulfillable_percentage}%
                      </span>
										<div className="ml-2 w-16 bg-gray-200 rounded-full h-2.5">
											<div className={`h-2.5 rounded-full ${product.fulfillable_percentage > 50 ? 'bg-green-500' : 'bg-red-500'}`} style={{ width: `${product.fulfillable_percentage}%` }}></div>
										</div>
									</div>
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									<div className="flex flex-wrap text-wrap max-w-[150px]">
										{Object.values(product.affected_orders || {}).join(', ')}
									</div>
								</td>
								<td className="px-6 py-4 text-sm text-gray-500">
									{product.deficit_details && Object.entries(product.deficit_details).map(([part, deficit]) => (
										<div key={part} className="flex items-center">
											<span className="inline-block h-2 w-2 rounded-full bg-red-400 mr-2"></span>
											{part}: <span className="text-red-500 font-medium ml-1">-{deficit}</span>
										</div>
									))}
								</td>
							</tr>
						))}
						</tbody>
					</table>
				) : (
					 <p className="text-gray-500 py-4">No fulfillable products data available.</p>
				 )}
			</div>
		</div>
	);
};

export default FulfillableProductsPanel;
